export const COLUMN_MARKUP_TYPE: string = "markupType";
export const COLUMN_GOOD_FROM: string = "activationDetails";
export const COLUMN_GOOD_UNTIL: string = "expiryDetails";
export const COLUMN_HOLD_STP: string = "stpHold";
export const COLUMN_AUTO_EXECUTE: string = "fillTypeRestriction";
export const COLUMN_PRIVATE: string = "isPrivateOrder";
export const COLUMN_ALLOW_PART_FILLS: string = "fillSupport";
export const COLUMN_SAVED_ORDER_ID: string = "orderId";
export const COLUMN_INSTRUMENT: string = "instrument";
export const COLUMN_ORDER_TYPE: string = "orderType";
export const COLUMN_CLIENT_INTENT: string = "clientIntent";
export const COLUMN_ACCOUNT_CODE: string = "accountCode";
export const COLUMN_CLIENT_CODE: string = "clientCode";
export const COLUMN_ORDER_AMOUNT: string = "fixedAmount";
export const COLUMN_ORDER_REQ_RATE: string = "requestRate";
export const COLUMN_VAL_DT: string = "valueDate";
export const COLUMN_CURRENCY: string = "fixedCcy";
export const COLUMN_TRAILING_TRIGGER: string = "forwardTrackingType";
export const COLUMN_TRADER_GROUP: string = "deskId";
export const COLUMN_PRODUCT: string = "product";
export const COLUMN_FIXING_SOURCE_CODE: string = "fixingSourceCd";
export const COLUMN_MARKUP: string = "markup";
export const COLUMN_FIXING_DATE: string = "fixingDate";
export const COLUMN_CL_TRADER: string = "clTrader";
export const COLUMN_EXTERNAL_REF: string = "externalClientReference";
export const COLUMN_ORDER_STATE: string = "orderState";
export const COLUMN_FWD_NETTING_ID: string = "fwdNettingId";
